











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { parseMarkdown } from '@/lib/markdownUtils';

@Component({
  name: 'MarkdownRenderer'
})
export default class MarkdownRenderer extends Vue {
  @Prop({ required: true })
  public content!: string;

  private imageDialog = false;
  private fullSizeImageUrl = '';
  private imageAlt = '';

  public get renderedContent(): string {
    return parseMarkdown(this.content);
  }

  @Watch('content')
  onContentChange() {
    // Re-attach click handlers when content changes
    this.$nextTick(() => {
      this.attachImageClickHandlers();
    });
  }

  mounted() {
    this.attachImageClickHandlers();
  }

  beforeDestroy() {
    this.removeImageClickHandlers();
  }

  private attachImageClickHandlers() {
    const container = this.$refs.markdownContainer as HTMLElement;
    if (!container) return;

    const images = container.querySelectorAll('img');
    images.forEach((img: HTMLImageElement) => {
      // Add cursor pointer style only
      img.style.cursor = 'pointer';

      // Add click handler
      img.addEventListener('click', this.onImageClick);
    });
  }

  private removeImageClickHandlers() {
    const container = this.$refs.markdownContainer as HTMLElement;
    if (!container) return;

    const images = container.querySelectorAll('img');
    images.forEach((img: HTMLImageElement) => {
      img.removeEventListener('click', this.onImageClick);
    });
  }

  private onImageClick(event: Event) {
    const img = event.target as HTMLImageElement;

    // Extract original URL from display URL
    // Convert: .../media/resized-1200/abc123.jpg -> .../media/abc123.jpg
    const displayUrl = img.src;
    const originalUrl = displayUrl.replace('/resized-1200/', '/');

    this.fullSizeImageUrl = originalUrl;
    this.imageAlt = img.alt || 'Image';
    this.imageDialog = true;
  }

  private closeImageViewer() {
    this.imageDialog = false;
  }
}
